import Swiper from 'swiper';
import {
  Navigation,
  Pagination,
  EffectFade,
  Autoplay,
  Mousewheel,
  Grid,
  FreeMode,
} from 'swiper/modules';

// Instead of this type of initialisation ;

// import Swiper from 'swiper';
// const swiper = new Swiper(selector, {options});

// You should use this :

// import SwiperSlider from './components/sliders/SwiperSlider';
// const swiper = new SwiperSlider(selector, {options});

export default class SwiperSlider {
  swiper = undefined;

  static paginationConfig = {
    clickable: true,
    renderBullet: (index, className) => {
      return `<button
            type="button"
            class="${className}"
            title="Groupe de slide numéro ${index + 1}"
          ><span class="sr-only">Slide numéro ${index + 1}</span></button>`;
    },
  };

  constructor(selector, options = {}) {
    const selectorType = typeof selector;
    let selectorClass;

    if (selectorType === 'object') {
      selectorClass = `.${selector.classList[0]}`;
    } else {
      selectorClass = selector;
    }

    let next = `${selectorClass}--next`;
    let prev = `${selectorClass}--prev`;
    let pagination = `${selectorClass}__pagination`;

    this.swiper = new Swiper(selector, {
      // Set default options.
      modules: [
        Navigation,
        Pagination,
        EffectFade,
        Autoplay,
        Grid,
        FreeMode,
        Mousewheel,
      ],
      a11y: {
        enabled: true,
        containerMessage: 'Contenu à balayer de droite à gauche',
        firstSlideMessage: 'Première slide',
        lastSlideMessage: 'Dernière slide',
        nextSlideMessage: 'Slide suivante',
        paginationBulletMessage: 'Aller à la slide numéro {{index}}',
        prevSlideMessage: 'Slide précédente',
        slideLabelMessage:
          'Slide {{index}} sur {{slidesLength}} slide(s) au total',
      },
      keyboard: {
        enabled: true,
      },
      grabCursor: true,
      watchOverflow: true,
      slideToClickedSlide: true,
      pagination: {
        ...SwiperSlider.paginationConfig,
        el: pagination,
      },
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
      // Add custom options.
      ...options,
    });
  }
}
